import React from "react";
import { Button } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const ShowMoreButtonStatic = ({ onClick }) => {
  return (
    <Button
      onClick={onClick}
      variant="contained"
      disableElevation
      disableRipple
      endIcon={<KeyboardArrowRightIcon />}
      sx={{
        textTransform: "none",
        alignItems: "center",
        backgroundColor: "#C93312",
        borderRadius: "22px",
        boxShadow: "none",
        color: "#fff",
        display: "inline-flex",
        gap: "0.15rem",
        justifyContent: "center",
        marginBottom: "20px",
        minWidth: "120px",
        padding: "6px 16px",
        transition: "transform 0.22s ease, box-shadow 0.22s ease",
        "&:hover": {
          backgroundColor: "#C93312",
          boxShadow: "0 6px 16px rgba(201, 51, 18, 0.3)",
          transform: "scale(1.06)",
        },
        "&:active": {
          backgroundColor: "#b52e10",
          boxShadow: "0 3px 10px rgba(201, 51, 18, 0.25)",
          transform: "scale(1.02)",
        },
        "& .MuiSvgIcon-root": {
          color: "#fff",
          fontSize: "1.2rem",
        },
      }}
    >
      Show More
    </Button>
  );
};

export default ShowMoreButtonStatic;
